<template>
  <div>
    <popup-add-messenger-venue ref="popupAddMessengerVenue" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Facebook pages</h3>
        <p class="mt-5">
          A venue's Facebook Business page must be added to list before it is
          usable in the Engage module.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="$refs.popupAddMessengerVenue.show()"
            v-if="
              $AuthService.hasPermission(
                'vp.crm.engageconfiguration.messengersync.createedit'
              )
            "
            type="relief"
            vslor="primary"
            >Add venue FB page</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="pageVenueIdentities"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Business page ID</vs-th>
          <vs-th>Venue name</vs-th>
          <vs-th>Page token</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.id }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="warning" class="product-order-status">
                  {{ tr.venueName }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-category">**********</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  v-if="
                    $AuthService.hasPermission(
                      'vp.crm.engageconfiguration.messengersync.createedit'
                    )
                  "
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="confirmDelete(tr.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popupAddMessengerVenue from "./PopupAddMessengerVenue.vue";

export default {
  components: { popupAddMessengerVenue },
  data() {
    return {
      selected: [],
      deleteId: "",
    };
  },
  methods: {
    confirmDelete(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this venue from the messenger engage module?",
        accept: this.deleteItem,
      });
    },
    async deleteItem() {
      await this.$store.dispatch("chat/deletePageVenueIdentity", this.deleteId);
    },
  },
  computed: {
    ...mapGetters({
      pageVenueIdentities: "chat/pageVenueIdentities",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("chat/getPageVenueIdentities");
    this.$vs.loading.close();
  },
};
</script>